/*
 * @Author: mzw
 * @Date: 2025-04-23 13:22:11
 * @LastEditTime: 2025-04-23 13:22:11
 * @LastEditors: mzw
 * @Description:
 */
export function randString(length) {
  const str = "0123456789abcdefghijklmnopqrstuvwxyz"
  const size = str.length
  let buf = []
  for (let i = 0; i < length; i++) {
      const rand = Math.random() * size
      buf.push(str.charAt(rand))
  }
  return buf.join("")
}

export function escapeHTML(html) {
  return html.replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
}